
import { defineComponent } from 'vue';
import vGenericErrorTable from '@/components/vGenericErrorTable.vue';
import vModal from "@/components/vModal.vue";

export default defineComponent({
  name: 'VImportErrorsModal',
  components: { vGenericErrorTable, vModal },
  props: {
    isOpen: Boolean,
    translations: Object,
    errorData: Array,
  },
  emits: ['cancel'],
  setup(_, { emit }) {
    function onCancel() {
      emit('cancel');
    }

    return { onCancel };
  },
});
